var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none",
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFDB",
    d: "M31 30V8.044l-8.584-4.34-.942-.552a6.357 6.357 0 0 0-.945-1.25 6.396 6.396 0 0 0-9.103 0 6.516 6.516 0 0 0-1.887 4.605c0 .16.035.317.045.476L.955 2.619v21.956l9.608 4.857 1.122-.452 9.608-3.886L31 30ZM28.854 9.385v17.104l-6.438-3.255V6.13l6.438 3.255Zm-15.91-5.948a4.265 4.265 0 0 1 6.068 0c.395.4.698.863.91 1.365l.043.108c.015.037.021.076.034.113.08.221.15.445.194.673a4.335 4.335 0 0 1-1.18 3.88l-3.035 3.068-3.035-3.068a4.403 4.403 0 0 1-.54-.666c-.029-.044-.046-.092-.072-.133a4.317 4.317 0 0 1-.326-.625 4.384 4.384 0 0 1-.32-1.645 4.34 4.34 0 0 1 1.258-3.07ZM3.1 23.234V6.13l6.44 3.255v17.104l-6.438-3.255Zm8.584-11.862 4.293 4.34 4.292-4.34v11.799l-8.585 3.472v-15.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFDB",
    d: "M15.978 7.674c.578 0 1.048-.624 1.048-1.395 0-.77-.47-1.395-1.048-1.395-.58 0-1.048.624-1.048 1.395 0 .77.469 1.395 1.048 1.395Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.8b2942221e3f17f4dadf3b879b3be180.svg";
export { ForwardRef as ReactComponent };